import React from 'react';
import { Route, Redirect, RouteProps, RouteComponentProps } from 'react-router-dom';

import { APICore } from '../helpers/api/apiCore';

interface PrivateRouteProps {
    component: React.ComponentType<any>;
    roles?: string[];   // ✅ MUST BE ARRAY
}

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */

const PrivateRoute = ({ component: Component, roles, ...rest }: PrivateRouteProps) => {
    const api = new APICore();

    return (
        <Route
            {...rest}
            render={(props: RouteComponentProps) => {
                if (api.isUserAuthenticated() === false) {
                    return (
                        <Redirect
                            to={{
                                pathname: '/auth/login',
                                state: { from: props['location'] },
                            }}
                        />
                    );
                }

                if (!roles || roles.length === 0) {
                    return <Component {...props} />;
                }

                const loggedInUser = api.getLoggedInUser();
                const userRole = (loggedInUser?.user?.role || loggedInUser?.role || 'admin').toLowerCase();

                // Get active workspace role if available
                let workspaceRole = '';
                try {
                    const storedWs = sessionStorage.getItem('active_workspace') || localStorage.getItem('active_workspace');
                    if (storedWs) {
                        const ws = JSON.parse(storedWs);
                        workspaceRole = (ws?.role || '').toLowerCase();
                        // Personal workspaces have full owner permissions for the account holder
                        if (ws?.workspace_type === 'personal') {
                            workspaceRole = 'owner';
                        }
                    }
                } catch (e) {}

                // If user is owner or admin in workspace or account, grant full access
                const isPrivileged =
                    userRole === 'admin' ||
                    userRole === 'owner' ||
                    userRole === 'superadmin' ||
                    workspaceRole === 'owner' ||
                    workspaceRole === 'admin';

                const normalizedRoles = roles.map((r) => r.toLowerCase());

                const hasAccess =
                    isPrivileged ||
                    normalizedRoles.includes(userRole) ||
                    (workspaceRole && normalizedRoles.includes(workspaceRole)) ||
                    normalizedRoles.includes('user') ||
                    normalizedRoles.includes('');

                if (!hasAccess) {
                    return <Redirect to="/Unauth" />;
                }

                return <Component {...props} />;
            }}
        />
    );
};

export default PrivateRoute;
